<div tabindex="0" class="default-card row card--me" [ngClass]="class" *ngIf="data">
    <div *ngIf="data.image; else defaultIcon" class="default-card__icon"
         [innerHTML]="data.image | storyblokImage:'stb-image'">
    </div>

    <ng-template #defaultIcon>
        <div class="default-card__icon" [innerHTML]="icon | safeHtml">
        </div>
    </ng-template>

    <div class="default-card__header">
        {{data.title}}
    </div>
    <div *ngIf="data.text" class="default-card__description storyblok-content"
            [innerHTML]="data.text | storyblokRichtext">
    </div>

    <div *ngIf="data.content" class="default-card__description storyblok-content"
         [innerHTML]="data.content | storyblokRichtext">
    </div>

    <div class="default-card__button storyblok-content">
        <storyblok-link [classList]="'btn btn--secondary'" *ngFor="let button of data.link"
                        [data]="button.link"></storyblok-link>
    </div>
</div>